// /welcome-tutorial: a brand-new account's first stop. verify_token sets `tutorial_gate`
// for accounts created after the gate went live (TUTORIAL_GATE_SINCE in api routes/auth.js)
// that haven't watched it yet; AppRoutes then sends every route here. When the walkthrough
// reaches its closing card it's recorded server-side and the app opens by itself after a
// short countdown (or at once via "continue"), where the post-register onboarding wizard
// picks up.
import React, {useCallback, useEffect, useRef, useState} from 'react'
import axios from 'axios'
import {TutorialDemo} from './TutorialDemo'
import './TutorialGate.scss'

const API_URL = process.env.REACT_APP_API_URL || ''

// Seconds between the end of the walkthrough and entering the app.
const AUTO_ENTER_S = 3

const TutorialGate: React.FC = () => {
  const [finished, setFinished] = useState(false)
  const [saving, setSaving] = useState(false)
  const [countdown, setCountdown] = useState(AUTO_ENTER_S)
  const leaving = useRef(false)
  const onFinished = useCallback(() => setFinished(true), [])

  const proceed = useCallback(async () => {
    if (leaving.current) return
    leaving.current = true
    setSaving(true)
    try {
      await axios.put(`${API_URL}/user/tutorial-watched`)
    } catch {}
    // Full load so verify_token re-runs and the gate is lifted.
    window.location.assign('/campaigns')
  }, [])

  // Finished → count down, then enter the app.
  useEffect(() => {
    if (!finished) return
    if (countdown <= 0) {
      proceed()
      return
    }
    const id = window.setTimeout(() => setCountdown((c) => c - 1), 1000)
    return () => window.clearTimeout(id)
  }, [finished, countdown, proceed])

  return (
    <div className='tut-gate'>
      <div className='tut-gate-banner' dir='rtl'>
        <b>ברוכים הבאים ל-FB Zipper! 👋</b>
        <span>לפני שמתחילים, צפו במדריך הקצר עד הסוף. הוא מראה בדיוק מה לעשות בכניסה הראשונה.</span>
      </div>
      <TutorialDemo onFinished={onFinished} />
      <div className='tut-gate-bar' dir='rtl'>
        <span>
          {!finished
            ? 'הכפתור ייפתח בסוף המדריך'
            : saving
            ? 'מעולה, סיימתם את המדריך!'
            : `מעולה, סיימתם את המדריך! נכנסים למערכת בעוד ${countdown}…`}
        </span>
        <button className='btn btn-primary' disabled={!finished || saving} onClick={proceed}>
          {saving ? 'נכנסים…' : 'המשך למערכת'}
        </button>
      </div>
    </div>
  )
}

export {TutorialGate}
